import * as Zod from 'zod';

export const eventTypesScheme = Zod.object({
  id: Zod.number(),
  label: Zod.string(),
});
